<div *ngIf="recipeOriginal">
  <form [formGroup]="formClassif">
    <div class="classification-row background-grey">
      <div class="classification-box">
        <div class="classification-box-title flex-small">{{ 'DIFFICULTY' | translate }}</div>
        <div class="classification-box-content flex-big">
          <div id="RecipesModifyClassificationAdvancedDifficultyLnk">
            <i
              class="fas fa-mitten space-h-s"
              [ngClass]="{ green: difficultyHoverIndex >= 0, dark: math.round((formClassif.value.difficulty / 100) * 4) / 4 >= 0.25 }"
              (click)="setDifficulty(25)"
              matTooltip="{{ 'DIFFICULTY_1' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="difficultyHoverIndex = 0"
              (mouseout)="difficultyHoverIndex = -1"
            ></i>
            <i
              class="fas fa-mitten space-h-s"
              [ngClass]="{ green: difficultyHoverIndex >= 1, dark: math.round((formClassif.value.difficulty / 100) * 4) / 4 >= 0.5 }"
              (click)="setDifficulty(50)"
              matTooltip="{{ 'DIFFICULTY_2' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="difficultyHoverIndex = 1"
              (mouseout)="difficultyHoverIndex = -1"
            ></i>
            <i
              class="fas fa-mitten space-h-s"
              [ngClass]="{ green: difficultyHoverIndex >= 2, dark: math.round((formClassif.value.difficulty / 100) * 4) / 4 >= 0.75 }"
              (click)="setDifficulty(75)"
              matTooltip="{{ 'DIFFICULTY_3' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="difficultyHoverIndex = 2"
              (mouseout)="difficultyHoverIndex = -1"
            ></i>
            <i
              class="fas fa-mitten space-h-s"
              [ngClass]="{ green: difficultyHoverIndex >= 3, dark: math.round((formClassif.value.difficulty / 100) * 4) / 4 >= 1 }"
              (click)="setDifficulty(100)"
              matTooltip="{{ 'DIFFICULTY_4' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="difficultyHoverIndex = 3"
              (mouseout)="difficultyHoverIndex = -1"
            ></i>
          </div>
          <div>
            {{ 'DIFFICULTY_TIPS' | translate }}
          </div>
        </div>
      </div>
      <div class="classification-box">
        <div class="classification-box-title flex-small">{{ 'COST' | translate }}</div>
        <div class="classification-box-content flex-big">
          <div id="RecipesModifyClassificationAdvancedCostLnk">
            <i
              class="fas fa-euro-sign space-h-s"
              [ngClass]="{ green: costHoverIndex >= 0, dark: math.round((formClassif.value.cost / 100) * 3) / 3 >= 0.33 }"
              (click)="setCost(33.33)"
              matTooltip="{{ 'COST_1' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="costHoverIndex = 0"
              (mouseout)="costHoverIndex = -1"
            ></i>
            <i
              class="fas fa-euro-sign space-h-s"
              [ngClass]="{ green: costHoverIndex >= 1, dark: math.round((formClassif.value.cost / 100) * 3) / 3 >= 0.66 }"
              (click)="setCost(66.66)"
              matTooltip="{{ 'COST_2' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="costHoverIndex = 1"
              (mouseout)="costHoverIndex = -1"
            ></i>
            <i
              class="fas fa-euro-sign space-h-s"
              [ngClass]="{ green: costHoverIndex >= 2, dark: math.round((formClassif.value.cost / 100) * 3) / 3 >= 1 }"
              (click)="setCost(100)"
              matTooltip="{{ 'COST_3' | translate }}"
              matTooltipClass="tooltip-main"
              aria-hidden="true"
              (mouseenter)="costHoverIndex = 2"
              (mouseout)="costHoverIndex = -1"
            ></i>
          </div>
          <div>
            {{ 'COST_TIPS' | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="classification-row background-grey flex-between">
      <div class="classification-box">
        <div class="classification-box-title flex-small">{{ 'CHEF' | translate }}</div>
        <div class="classification-box-content flex-big">
          <mat-form-field appearance="fill" class="form-field-chef">
            <mat-label>{{ 'CHEF' | translate }}</mat-label>
            <input
              id="RecipesModifyClassificationAdvancedChefTxt"
              formControlName="chef"
              matInput
              type="text"
              value="{{ recipeOriginal.chef }}"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="classification-box">
        <ng-container *ngIf="isReworkAllowed">
          <div class="classification-box-title space-h-xxl" style="flex-grow: initial">{{ 'OLD_RATING' | translate }}</div>
          <div class="classification-box-content flex-big">
            <mat-form-field appearance="fill">
              <mat-label *ngIf="!recipeOriginal?.oldRating">{{ 'NO_RATING' | translate }}</mat-label>
              <mat-label *ngIf="recipeOriginal?.oldRating as rating">{{ rating | number: '1.0-2' }} </mat-label>
              <input id="RecipesModifyClassificationAdvancedRateTxt" matInput type="text" [disabled]="true" />
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="classification-row background-grey flex-between">
      <div class="classification-box">
        <div class="classification-box-title flex-small">{{ 'AI_RECIPE' | translate }}</div>
        <div class="classification-box-content flex-big">
          <mat-slide-toggle
            class="ai-generated-toggle"
            id="RecipesModifyClassificationAdvancedIsAIGenerated"
            formControlName="isAIGenerated"
            color="primary"
            hideIcon="true"
            aria-labelledby="RecipesModifyClassificationAdvancedIsAIGeneratedLabel"
            (change)="isAIGeneratedChange.emit($event.checked)"
          >
          </mat-slide-toggle>
          <div id="RecipesModifyClassificationAdvancedIsAIGeneratedLabel">{{ 'AI_RECIPE_LABEL' | translate }}</div>
        </div>
      </div>
      <div class="classification-box"></div>
    </div>

    <div class="classification-row">
      <div class="classification-box input-box">
        <div class="button-media">
          <app-media-upload
            [showOnlyButton]="true"
            [withUrlInput]="true"
            [formControlName]="'resourceMedias'"
            (closeMedia)="closeMediaUpload()"
          ></app-media-upload>
        </div>
        <app-medias-list [recipeOriginal]="recipeOriginal"></app-medias-list>
      </div>
    </div>

    <div class="classification-row">
      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'PACKS' | translate }}</div>
        <div class="classification-box-content flex-big">
          <app-form-field-select-autocomplete
            class="input-center"
            [label]="'PACKS'"
            [showBracket]="false"
            [control]="formClassif.controls.packs"
            [useKeyAndName]="true"
            [completeList]="packs"
            appearance="fill"
            [market]="recipeOriginal.market"
            [lang]="recipeOriginal.lang"
            (digitalAssetsByPack)="initDigitalAsset($event)"
          ></app-form-field-select-autocomplete>
        </div>
      </div>

      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'OCCASIONS' | translate }}</div>
        <div class="classification-box-content flex-big">
          <app-form-field-select-autocomplete
            class="input-center"
            [label]="'OCCASIONS'"
            [showBracket]="false"
            [control]="formClassif.controls.occasions"
            [useKeyAndName]="true"
            [completeList]="occasions"
            appearance="fill"
          ></app-form-field-select-autocomplete>
        </div>
      </div>
    </div>
    <div class="classification-row">
      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'EXCLUDED_FOOD' | translate }}</div>
        <div class="classification-box-content flex-big">
          <mat-form-field class="input-center" appearance="fill">
            <mat-label>{{ 'EXCLUDED_FOOD' | translate }}</mat-label>
            <mat-select formControlName="excludedFoods" *ngIf="excludedFoods && !isSemanticAllowed" multiple>
              <div id="RecipesModifyClassificationAdvancedNonConsumedChkBoxLst">
                <mat-option *ngFor="let excludedFood of excludedFoods | sortBy: 'translatedName'" [value]="excludedFood.key"
                  >{{ excludedFood.translatedName }}
                </mat-option>
              </div>
            </mat-select>
            <mat-select
              id="RecipesModifyClassificationAdvancedNonConsumedBtn"
              formControlName="detectedExcludedFoods"
              *ngIf="excludedFoods && isSemanticAllowed"
              multiple
            >
              <div id="RecipesModifyClassificationAdvancedNonConsumedChkBoxLst">
                <mat-option
                  *ngFor="let excludedFood of excludedFoods | sortBy: 'translatedName'"
                  [value]="excludedFood.key"
                  [disabled]="isSemanticDone"
                  >{{ excludedFood.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'COURSE_TYPE' | translate }}</div>
        <div class="classification-box-content flex-big">
          <app-form-field-select-autocomplete
            class="input-center"
            [label]="'COURSE_TYPE'"
            [showBracket]="false"
            [control]="formClassif.controls.courses"
            [useKeyAndName]="true"
            [completeList]="courseTypes"
            appearance="fill"
          ></app-form-field-select-autocomplete>
        </div>
      </div>
    </div>

    <div class="classification-box input-box">
      <div class="classification-box-title space-h-xxl" style="flex-grow: initial">{{ 'TREE_PRODUCTS' | translate }}</div>
      <div class="space-l-xxl">
        <button
          class="space-h-s btn-border"
          id="RecipesModifyClassificationAdvancedProductCatalogueBtn"
          mat-raised-button
          *ngIf="!showTree"
          (click)="showTree = true"
        >
          {{ 'TREE_LOAD' | translate }}
        </button>
      </div>
      <app-catalog
        class="catalog"
        *ngIf="showTree"
        [inputCatalogObj]="{
          formRecipe: formClassif,
          lang: recipeOriginal.lang,
          market: recipeOriginal.market,
          domain: recipeOriginal.domain,
          typeAbaque: abacusType,
        }"
      >
      </app-catalog>
    </div>
    <div class="classification-row">
      <div class="classification-box input-box">
        <div class="classification-box-title flex-small" id="RecipesModifyClassificationAdvancedDigitalAssetTxt">
          {{ 'DIGITAL_ASSET' | translate }}
        </div>
        <div class="classification-box-content" *ngIf="showDigitalAssets">
          <app-form-field-select-autocomplete
            class="input-center"
            [label]="'DIGITAL_ASSET'"
            [showBracket]="false"
            [control]="formClassif.controls.digitalAssets"
            [useKeyAndName]="true"
            [completeList]="digitalAssets"
            appearance="fill"
            [market]="recipeOriginal.market"
            [lang]="recipeOriginal.lang"
            [isDisabled]="digitalAssetDisabled"
          >
          </app-form-field-select-autocomplete>
        </div>
        <div class="classification-box-content" *ngIf="!showDigitalAssets">
          <mat-chip-set>
            <mat-chip *ngFor="let digitalAsset of digitalAssetsByPack">{{ digitalAsset }}</mat-chip>
          </mat-chip-set>
        </div>
      </div>
      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'AVAILABILITY' | translate }}</div>
        <div class="classification-box-content">
          <mat-form-field class="input-center" appearance="fill">
            <mat-label>{{ 'AVAILABILITY' | translate }}</mat-label>
            <mat-select id="RecipesModifyClassificationAdvancedVisibilityBtn" formControlName="privacyLevel">
              <div>
                <mat-option *ngFor="let privacie of refDataPrivacies | sortBy: 'translatedName'" [value]="privacie.key"
                  >{{ privacie.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="classification-row">
      <div class="classification-box input-box">
        <div class="classification-box-title flex-small">{{ 'PARTNER' | translate }}</div>
        <div class="classification-box-content">
          <mat-form-field class="form-field-fixed-l margin-input" appearance="fill">
            <mat-label>{{ 'PARTNER' | translate }}</mat-label>
            <mat-select id="RecipesModifyClassificationAdvancedPartnerBtn" formControlName="partner">
              <div id="RecipesModifyClassificationAdvancedPartnerLst">
                <mat-option *ngIf="(partnersList?.length || 0) > 0"></mat-option>
                <mat-option *ngFor="let partner of partnersList | sortBy: 'name'" [value]="partner.content.key">
                  {{
                    partner.content.name && recipeOriginal.market && recipeOriginal.lang && partner.content.name[recipeOriginal.market]
                      ? partner.content.name[recipeOriginal.market][recipeOriginal.lang]
                      : partner.content.key
                  }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="divider">
      <mat-divider></mat-divider>
    </div>

    <h4 class="classification-box-general">
      {{ 'CLASSIFICATION_GENERAL' | translate }}
    </h4>

    <div *ngIf="recipeClassifications && recipeClassificationTypes" class="classification-general">
      <ng-container *ngFor="let types of recipeClassificationTypes">
        <ng-container
          *ngIf="
            !(
              !abacusType &&
              (types.key === 'COOKING_MODE' ||
                types.key === 'FOOD_FRESHNESS' ||
                types.key === 'FOOD_CUTTING' ||
                types.key === 'FOOD_COOKING')
            )
          "
        >
          <app-form-field-select-autocomplete
            class="space-h-m classification-general-item"
            *ngIf="types.key !== 'RICH_IN'"
            [label]="types.translatedName"
            [showBracket]="false"
            [control]="formClassif.controls.classifications"
            [useKeyAndName]="true"
            [hideEmpty]="true"
            [isDisabled]="filterWithKey(recipeClassifications, types.key).length === 0 || types.key === 'FOOD_COOKING'"
            [completeList]="filterWithKey(recipeClassifications, types.key)"
            appearance="fill"
          ></app-form-field-select-autocomplete>

          <mat-form-field class="space-h-m classification-general-item" *ngIf="types.key === 'RICH_IN'" appearance="fill">
            <mat-label>{{ types.translatedName }}</mat-label>
            <mat-select formControlName="classificationRichIn" [disabled]="classificationRichInList.length === 0">
              <mat-option *ngFor="let classif of classificationRichInList | sortBy: 'translatedName'" [value]="classif.key"
                >{{ classif.labelInt }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-container>
    </div>
    <div class="buttons-container">
      <button
        class="btn-warn"
        mat-raised-button
        id="RecipesModifyClassificationAdvancedResetBtn"
        (click)="reset()"
        [disabled]="formClassif.pristine"
      >
        {{ 'RESET_CLASSIFICATIONS' | translate }}
      </button>
      <button
        class="btn-submit space-l-s"
        mat-raised-button
        id="RecipesModifyClassificationAdvancedSaveBtn"
        (click)="save()"
        [disabled]="formClassif.invalid || formClassif.pristine"
      >
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </form>
</div>
